module.exports = {
  messages: {
    CN: {
      'deliveryChannelManagement.add': '新建',
      'deliveryChannelManagement.deliveryChannelManagement': '发货渠道管理',
      'deliveryChannelManagement.name': '发货渠道名称',
      'deliveryChannelManagement.receivingTimeType': '收货时间类型',
      'deliveryChannelManagement.productQuantity': '商品数量',
      'deliveryChannelManagement.status': '状态',
      'deliveryChannelManagement.updateTime': '更新时间',
      'deliveryChannelManagement.operation': '操作',
      'deliveryChannelManagement.zhCN': '简体',
      'deliveryChannelManagement.enable': '启用',
      'deliveryChannelManagement.disable': '停用',
      'deliveryChannelManagement.edit': '编辑',
      'deliveryChannelManagement.delete': '删除',
      'deliveryChannelManagement.dateTime': '日期时间',
      'deliveryChannelManagement.time': '时间',
      'deliveryChannelManagement.remark': '备注',
      'deliveryChannelManagement.receivingTimeTypeToolTip': '下单时客户指定收货时间的类型',
      'deliveryChannelManagement.confirmPrompt': '确定要修改吗？',
      'deliveryChannelManagement.deletePromp': '确定要删除吗？',
      'deliveryChannelManagement.confirm': '确定',
      'deliveryChannelManagement.cancel': '取消',
      'deliveryChannelManagement.updateSuccessfully': '更新成功',
      'deliveryChannelManagement.deleteSuccessfully': '删除成功',
      'deliveryChannelManagement.addSuccessfully': '新增成功',
      'deliveryChannelManagement.pleaseEnter': '请输入',
      'deliveryChannelManagement.deliveryChannel': '发货渠道'
    },
    JP: {
      'deliveryChannelManagement.add': '新規作成',
      'deliveryChannelManagement.deliveryChannelManagement': '发货渠道管理',
      'deliveryChannelManagement.name': '发货渠道名称',
      'deliveryChannelManagement.receivingTimeType': '收货时间类型',
      'deliveryChannelManagement.productQuantity': '商品数量',
      'deliveryChannelManagement.status': '状態',
      'deliveryChannelManagement.updateTime': '更新時間',
      'deliveryChannelManagement.operation': '操作',
      'deliveryChannelManagement.zhCN': '简体',
      'deliveryChannelManagement.enable': '有効',
      'deliveryChannelManagement.disable': '無効',
      'deliveryChannelManagement.edit': '编辑',
      'deliveryChannelManagement.delete': '削除',
      'deliveryChannelManagement.dateTime': '日期时间',
      'deliveryChannelManagement.time': '时间',
      'deliveryChannelManagement.remark': '备注',
      'deliveryChannelManagement.receivingTimeTypeToolTip': '下单时客户指定收货时间的类型',
      'deliveryChannelManagement.confirmPrompt': '确定要修改吗？',
      'deliveryChannelManagement.deletePromp': '削除してもよろしいですか？',
      'deliveryChannelManagement.confirm': '確定',
      'deliveryChannelManagement.cancel': 'キャンセル',
      'deliveryChannelManagement.updateSuccessfully': '更新成功',
      'deliveryChannelManagement.deleteSuccessfully': '削除しました',
      'deliveryChannelManagement.addSuccessfully': '追加しました',
      'deliveryChannelManagement.pleaseEnter': '入力してください',
      'deliveryChannelManagement.deliveryChannel': '发货渠道'
    }
  }
};